import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import round from "lodash/round";
import swal from "sweetalert2";
import CopyToClipboard from "react-copy-to-clipboard";
import { scrollToTop } from "../../../helpers/utils";
import {deleteAlert, getAllAlert, getStatAlert} from "../../../actions/entities/alertMPG";
import Loader from "../../../components/Loader";

import '../index.css';

class notificationsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: null,
            order: 'asc',
            loading: false,
            stats: {},
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        const onSuccessStats = (response) => this.setState({ stats: response });
        const onSuccess = (response) => {
            this.setState({ list: response.alerts, loading: false });
            if (response.alerts && response.alerts.length) {
                dispatch(getStatAlert(
                    { alertsIds: response.alerts.map(a => a.id) },
                    onSuccessStats
                ));
            }
        };
        this.setState({ loading: true });
        dispatch(getAllAlert(onSuccess));
        scrollToTop();
    }

    checkDelete(alertId) {
        const { dispatch } = this.props;
        const onSuccess = () => {
            const { list } = this.state;
            const freshList = this.state.list;
            list.forEach((value, index) => {
                if (alertId === value.id) {
                    freshList.splice(index, 1);
                    this.setState({ list: freshList });
                }
            });
        };
        swal({
            title: 'Are you sure ?',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Yes',
            cancelButtonText:
                'No',
        }).then(() => {
            dispatch(deleteAlert(alertId, onSuccess));
        }).catch(error => {
            console.log(error);
        })
    }

    onCopy() {
        swal({
            title: 'Copied !',
            type: 'success',
        })
    }

    orderList(type) {
        const { stats } = this.state;
        if (type === 'id' || type === 'name') {
            this.setState({ list: orderBy(this.state.list, type, this.state.order), type, order: this.state.order === 'asc' ? 'desc' : 'asc' });
        } else if (stats) {
            this.setState({
                list:
                    orderBy(
                        this.state.list,
                        n => {
                            if (stats[n.id]) {
                                if (type === 'reactivityRate') return round((stats[n.id].uniqClicks / stats[n.id].uniqViews) * 100, 2);
                                if (type === 'openRate') return round((stats[n.id].uniqViews / stats[n.id].deliveries) * 100, 2);
                                return stats[n.id][type];
                            }
                            return 0;
                        }
                        ,this.state.order
                    ),
                type,
                order: this.state.order === 'asc' ? 'desc' : 'asc'
            });
        }
    }

    render() {
        const { list, loading, stats } = this.state;
        return (
            <div id="alertsList">
                <header className="content-header">
                    <h1>
                        Alerts InApp list
                    </h1>
                </header>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-default">
                                <div className="box-header with-border">
                                    <table className="table table-responsive table-striped text-center">
                                        <thead className="fixedThead">
                                        <tr>
                                            <th style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => this.orderList('name')}>Name</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('deliveries')}>Sent</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('views')}>Views</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('clicks')}>Clicks</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('uniqViews')}>Unique Views</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('openRate')}>Open rate</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('uniqClicks')}>Unique Clicks</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.orderList('reactivityRate')}>Reactivity rate</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!list && loading && <Loader/>}
                                        {list && map(list, n => (
                                            <tr id="bodyTable">
                                                <th style={{ textAlign: 'left', fontWeight: 'bold' }}>{n.name}</th>
                                                <th>{stats[n.id] ? stats[n.id].deliveries.toLocaleString() : '-'}</th>
                                                <th>{stats[n.id] ? stats[n.id].views.toLocaleString() : '-'}</th>
                                                <th>{stats[n.id] ? stats[n.id].clicks.toLocaleString() : '-'}</th>
                                                <th>{stats[n.id] ? stats[n.id].uniqViews.toLocaleString() : '-'}</th>
                                                <th>{stats[n.id] && stats[n.id].deliveries ? `${round((stats[n.id].uniqViews / stats[n.id].deliveries) * 100, 2)}%` : '-'}</th>
                                                <th>{stats[n.id] ? stats[n.id].uniqClicks : '-'}</th>
                                                <th>{stats[n.id] ? `${round((stats[n.id].uniqClicks / stats[n.id].uniqViews) * 100, 2)}%` : '-'}</th>
                                                <th className="thId">
                                                    <div className="btn-group">
                                                        <CopyToClipboard
                                                            text={`?debug=${n.id}`}
                                                            onCopy={() => this.onCopy()}
                                                            className="btn btn-primary"
                                                        >
                                                            <p>Link debug</p>
                                                        </CopyToClipboard>
                                                        <button
                                                            className="btn btn-warning"
                                                            onClick={() => this.props.history.push({
                                                                pathname: `/alertMPG/modify/${n.id}`,
                                                            })}
                                                        >
                                                            Modify
                                                        </button>
                                                        <button
                                                            className="btn"
                                                            onClick={() => this.props.history.push({
                                                                pathname: `/alertMPG/create`,
                                                                search: `?duplicate=${n.id}`,
                                                            })}
                                                        >
                                                            Duplicate
                                                        </button>
                                                        <button
                                                            className="btn btn-danger"
                                                            onClick={() => this.checkDelete(n.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                </th>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
)(notificationsList);



// WEBPACK FOOTER //
// ./src/pages/AlertMPG/List/index.js